export enum ApiServiceApplicationDocumentKind {
	Undefined = 'Undefined',
	FactureInvoice = 'FactureInvoice',
	Utd = 'Utd',
	ServiceAcceptanceCertificate = 'ServiceAcceptanceCertificate',
	Agreement = 'Agreement',
	OrderAssignment = 'OrderAssignment',
	WorkOrder = 'WorkOrder',
	ServiceConfirmationDocument = 'ServiceConfirmationDocument',
	Invoice = 'Invoice',
	OrganizationCharter = 'OrganizationCharter',
	FoundationAgreement = 'FoundationAgreement',
	GraphicAnnex = 'GraphicAnnex',
	BuildingPermit = 'BuildingPermit',
	NatureInspectorateResolution = 'NatureInspectorateResolution',
	ChiefStateExpertise = 'ChiefStateExpertise',
	ProvidingWaterFacilityDecision = 'ProvidingWaterFacilityDecision',
	RosfishingConclusion = 'RosfishingConclusion',
	OtherDocument = 'OtherDocument',
	GuaranteeLetter = 'GuaranteeLetter',
}
